
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hT4Zj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $21bc9f73f22e1c99$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PANEL_ID", () => (parcelRequire("b8A8x")).PANEL_ID);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => (parcelRequire("b8A8x")).SIDEBAR_WIDTH);
$parcel$export(module.exports, "useSetProjectListRightPanelState", () => (parcelRequire("g0buz")).useSetProjectListRightPanelState);

var $ed8DK = parcelRequire("ed8DK");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $hsmeR = parcelRequire("hsmeR");

var $8zOmE = parcelRequire("8zOmE");
var $12d8n = parcelRequire("12d8n");

var $b8A8x = parcelRequire("b8A8x");

var $3YLJK = parcelRequire("3YLJK");

var $g0buz = parcelRequire("g0buz");
const $21bc9f73f22e1c99$var$JiraProjectsTemplateListRightPanel = ({ queries: { templatesQueryRef: templatesQueryRef } })=>{
    const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const rootQueryRef = (0, $8Uumt.usePreloadedQuery)((0, $ed8DK.default), templatesQueryRef);
    const { jira: jira } = rootQueryRef;
    const isAnonymous = templatesQueryRef?.variables.isAnonymous;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $12d8n.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (isAnonymous || !jira) return;
        if (!(typeof jira?.sidebarExperimentTemplates?.totalCount === 'number') || !(jira?.sidebarExperimentTemplates?.totalCount > 0) || !jira?.userPreferences?.projectListRightPanelState || !jira?.canCreateProject) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebarEligibility failed');
            return;
        }
        if (jira?.userPreferences?.projectListRightPanelState === 'OPEN') openRightSidebar((0, $b8A8x.PANEL_ID), (0, $b8A8x.SIDEBAR_WIDTH), false, true);
        if (jira?.userPreferences?.projectListRightPanelState === 'CLOSED') closeRightSidebar((0, $b8A8x.PANEL_ID));
    }, [
        openRightSidebar,
        closeRightSidebar,
        createAnalyticsEvent,
        isAnonymous,
        jira?.sidebarExperimentTemplates?.totalCount,
        jira?.userPreferences?.projectListRightPanelState,
        jira?.canCreateProject,
        jira
    ]);
    const rightSidebarCurrentState = (0, $hsmeR.useActiveRightSidebarState)();
    const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
    const prevPanelIdRef = (0, $5uXOq.useRef)();
    const delayRef = (0, $5uXOq.useRef)(undefined);
    const panelId = rightSidebarCurrentState?.panelId;
    /**
   * This use effect is used to add (when is necessary) a delay
   * in the panelId => localPanelId syncing
   */ (0, $5uXOq.useEffect)(()=>{
        clearTimeout(delayRef.current);
        if (prevPanelIdRef.current === (0, $b8A8x.PANEL_ID)) {
            /**
       * The right-sidebar is showing the templates panel...
       */ if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) /**
         * and is open, not collapsed and we want to show a panel
         * with an ID !== PANEL_ID
         */ setLocalPanelId(panelId);
            else /**
         * and we want to close it
         */ delayRef.current = setTimeout(()=>{
                setLocalPanelId(panelId);
            }, 310);
        } else /**
       * If the right sidebar is not showing the templates panel,
       * we just keep localPanelId in sync with panelId
       */ setLocalPanelId(panelId);
        prevPanelIdRef.current = panelId;
        return ()=>clearTimeout(delayRef.current);
    }, [
        panelId,
        rightSidebarCurrentState
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            closeRightSidebar((0, $b8A8x.PANEL_ID));
        }, [
        closeRightSidebar
    ]);
    if (localPanelId !== (0, $b8A8x.PANEL_ID)) return null;
    if (isAnonymous) return null;
    if (!rootQueryRef?.jira) throw new Error('Failed to load sidebar content');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3YLJK.default), {
        rootQueryRef: rootQueryRef.jira
    });
};
const $21bc9f73f22e1c99$var$JiraProjectsTemplateListRightPanelContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "right-sidebar-layout-component",
        packageName: "jiraGrowthRecommendationsInProjectList"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21bc9f73f22e1c99$var$JiraProjectsTemplateListRightPanel, props));
var $21bc9f73f22e1c99$export$2e2bcd8739ae039 = $21bc9f73f22e1c99$var$JiraProjectsTemplateListRightPanelContainer;

});
parcelRegister("ed8DK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca9939d69009c10e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8e56af6d3f13038fc4f0401113514fc9>>
 * @relayHash 53ebcedfde32e6f696cc7d8a2593a5b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f205f5060df8334465ed389c690fad308d9c1c3556c874884043528322963b4f

var $eiowN = parcelRequire("eiowN");
const $ca9939d69009c10e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "projectListRightPanelState"
    }, v4 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "experimentKey",
            "value": "sidebarExperiment"
        }
    ], v5 = {
        "alias": "sidebarExperimentTemplates",
        "args": v4 /*: any*/ ,
        "concreteType": "JiraProjectListViewTemplateConnection",
        "kind": "LinkedField",
        "name": "projectListViewTemplates",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "totalCount"
            }
        ]
    }, v6 = {
        "alias": "canCreateProject",
        "args": [
            v1 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "type",
                "value": "CREATE_PROJECT"
            }
        ],
        "kind": "ScalarField",
        "name": "canPerform"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ui_projectsDirectoryTemplatesSidebar_RecommendationsInProjectList"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraUserPreferences",
                                    "kind": "LinkedField",
                                    "name": "userPreferences",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ClientExtension",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraProjectListViewTemplateConnection",
                                    "kind": "LinkedField",
                                    "name": "projectListViewTemplates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProjectListViewTemplateItem",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "templateType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "productKey"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isProductLicensed"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "shortDescription"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isPremiumOnly"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canCreate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "recommendationSessionId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "iconUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "iconDarkUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "previewUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "previewDarkUrl"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f205f5060df8334465ed389c690fad308d9c1c3556c874884043528322963b4f",
            "metadata": {},
            "name": "src_projectsDirectoryTemplatesSidebar_RecommendationsInProjectListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ca9939d69009c10e$var$node.hash = "092f3e62a507116f9c083a6f0b93970a";
(0, $eiowN.PreloadableQueryRegistry).set($ca9939d69009c10e$var$node.params.id, $ca9939d69009c10e$var$node);
var $ca9939d69009c10e$export$2e2bcd8739ae039 = $ca9939d69009c10e$var$node;

});

parcelRegister("b8A8x", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $a27b9c5e490bee8d$export$780035d9fe48eb32);
$parcel$export(module.exports, "PANEL_ID", () => $a27b9c5e490bee8d$export$e1d562d81d0e502d);
$parcel$export(module.exports, "PROJECT_CREATE_SOURCE", () => $a27b9c5e490bee8d$export$280536374592bda3);
$parcel$export(module.exports, "PROJECT_TYPE_TARGETS_MAP", () => $a27b9c5e490bee8d$export$990484f4e8c06c90);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $a27b9c5e490bee8d$export$29629758934356a6);

var $fttKr = parcelRequire("fttKr");

var $d6PIe = parcelRequire("d6PIe");
const $a27b9c5e490bee8d$export$780035d9fe48eb32 = 365;
const $a27b9c5e490bee8d$export$e1d562d81d0e502d = 'recommendationsInProjectList';
const $a27b9c5e490bee8d$export$675d6d49067be942 = 'recommendationsInProjectListHoverAnchor';
const $a27b9c5e490bee8d$export$280536374592bda3 = 'recommendationsInProjectList';
const $a27b9c5e490bee8d$export$990484f4e8c06c90 = {
    BUSINESS: (0, $fttKr.Targets).JIRA_CORE,
    SOFTWARE: (0, $fttKr.Targets).JIRA_SOFTWARE,
    SERVICE_DESK: (0, $fttKr.Targets).JIRA_SERVICE_DESK,
    PRODUCT_DISCOVERY: (0, $fttKr.Targets).JIRA_PRODUCT_DISCOVERY
};
const $a27b9c5e490bee8d$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $d6PIe.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $d6PIe.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $d6PIe.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $d6PIe.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("3YLJK", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b5dc24f07146f55$export$2e2bcd8739ae039);

var $e7L79 = parcelRequire("e7L79");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jgPn0 = parcelRequire("jgPn0");

var $lxMAk = parcelRequire("lxMAk");

var $3fgs9 = parcelRequire("3fgs9");

var $eMGUj = parcelRequire("eMGUj");
var $eRozQ = parcelRequire("eRozQ");

var $gPt5r = parcelRequire("gPt5r");
var $85183 = parcelRequire("85183");
var $kHj7L = parcelRequire("kHj7L");
var $gDPDy = parcelRequire("gDPDy");

var $4R6GH = parcelRequire("4R6GH");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $iqLcb = parcelRequire("iqLcb");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $12d8n = parcelRequire("12d8n");

var $bKCrm = parcelRequire("bKCrm");

var $2tT7R = parcelRequire("2tT7R");

var $eAf7Q = parcelRequire("eAf7Q");

var $b8A8x = parcelRequire("b8A8x");

var $bikf7 = parcelRequire("bikf7");

var $g0buz = parcelRequire("g0buz");

var $44MrF = parcelRequire("44MrF");

var $58Hlr = parcelRequire("58Hlr");

var $iYN9U = parcelRequire("iYN9U");
const $9b5dc24f07146f55$var$RecommendationsInProjectList = ({ rootQueryRef: rootQueryRef })=>{
    const [templatePreviewKey, setTemplatePreviewKey] = (0, $5uXOq.useState)(null);
    const environment = (0, $2tT7R.useEnvironment)();
    const { fireViewedUIEvent: fireViewedUIEvent } = (0, $eAf7Q.useFireCrossFlowAnalyticsEvents)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $12d8n.useAnalyticsEvents)();
    const { methods: { open: openProjectCreate } } = (0, $bKCrm.useProjectCreateDrawer)();
    const buttonEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { projectListViewTemplates: projectListViewTemplates, userPreferences: userPreferences } = (0, $8Uumt.useFragment)((0, $e7L79.default), rootQueryRef);
    const setProjectListRightPanelState = (0, $g0buz.useSetProjectListRightPanelState)(userPreferences?.__id);
    const onCloseClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(buttonEvent, 'closeButton');
        setProjectListRightPanelState('CLOSED');
    }, [
        buttonEvent,
        setProjectListRightPanelState
    ]);
    const templates = (0, $5uXOq.useMemo)(()=>projectListViewTemplates?.nodes?.filter((template)=>!!template) ?? [], [
        projectListViewTemplates?.nodes
    ]);
    const templatePreviewRef = (0, $5uXOq.useMemo)(()=>templates.find((template)=>template.key === templatePreviewKey), [
        templatePreviewKey,
        templates
    ]);
    const recommendedProductIds = (0, $5uXOq.useMemo)(()=>Array.from(templates.reduce((acc, template)=>{
            const { isProductLicensed: isProductLicensed, productKey: productKey } = template;
            if (!isProductLicensed) acc.add((0, $b8A8x.getProductTypeCcpReferenceIdMapForEnv)(environment)[productKey]);
            return acc;
        }, new Set())), [
        environment,
        templates
    ]);
    const onMoreTemplatesClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(buttonEvent, 'moreTemplatesButton');
        openProjectCreate({
            showExperienceSelection: false,
            source: (0, $b8A8x.PROJECT_CREATE_SOURCE)
        });
    }, [
        buttonEvent,
        openProjectCreate
    ]);
    (0, $5uXOq.useEffect)(()=>{
        recommendedProductIds.length > 0 && fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'projectsDirectorySidebar'
        }, {
            recommendedProductIds: recommendedProductIds,
            source: 'projectsDirectorySidebarSection'
        });
    }, [
        fireViewedUIEvent,
        recommendedProductIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: true,
        placement: "left-start",
        offset: [
            0,
            0
        ],
        autoFocus: false,
        messageId: "projects-directory-templates-sidebar.ui.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ...triggerProps,
                "aria-expanded": undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
                id: "jira-project-list-side-panel",
                xcss: $9b5dc24f07146f55$var$SidebarContainerStyles,
                ...(0, $4R6GH.fg)('jfp_a11y_autodev_fix_templates_dialog_role') ? {
                    role: 'dialog',
                    'aria-modal': 'false',
                    'aria-labelledby': 'templates-dialog-title'
                } : {}
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHj7L.default), {
                as: "ul",
                xcss: $9b5dc24f07146f55$var$ExperimentSidebarContentStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
                as: "li"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHj7L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85183.default), {
                xcss: $9b5dc24f07146f55$var$TitleStyles,
                alignBlock: "center",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lxMAk.default), {
                size: "xsmall",
                id: (0, $4R6GH.fg)('jfp_a11y_autodev_fix_templates_dialog_role') ? 'templates-dialog-title' : undefined,
                as: (0, $4R6GH.fg)('jfp-a11y-team_autodev_header_fixes') ? 'h2' : undefined
            }, formatMessage((0, $bikf7.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
                xcss: $9b5dc24f07146f55$var$ButtonBoxStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgPn0.default), {
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fgs9))), {
                    spacing: "spacious",
                    label: ""
                }),
                "aria-label": formatMessage((0, $bikf7.messages).closeButton),
                "data-testId": "projects-directory-templates-sidebar.ui.close-templates-panel",
                appearance: "subtle",
                onClick: onCloseClick
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
                as: "p",
                xcss: $9b5dc24f07146f55$var$SubtitleStyles
            }, formatMessage((0, $bikf7.messages).subtitle)))), templates.map((cardRef, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $44MrF.TemplateCard), {
                    key: cardRef.key,
                    index: index,
                    dataRef: cardRef,
                    recommendedProductIds: recommendedProductIds,
                    setTemplatePreviewKey: setTemplatePreviewKey
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
                as: "li"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgPn0.default), {
                appearance: "link",
                spacing: "none",
                label: formatMessage((0, $bikf7.messages).moreTemplatesLink),
                onClick: ()=>onMoreTemplatesClick()
            }, formatMessage((0, $bikf7.messages).moreTemplatesLink)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
                attributes: {
                    templates: templates.map(({ key: key })=>key),
                    templateTypes: templates.map(({ templateType: templateType })=>templateType)
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iYN9U.JiraProjectListSidePanelSkipLink), null))),
        content: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
                id: "template-preview-wrapper",
                packageName: "jiraGrowthRecommendationsInProjectList"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eMGUj.default), null, templatePreviewRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eRozQ.default), {
                duration: "medium"
            }, (fadeInProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", fadeInProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $58Hlr.TemplatePreview), {
                    update: update,
                    previewRef: templatePreviewRef
                })))))
    });
};
const $9b5dc24f07146f55$var$RecommendationsInProjectListContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "projectListTemplates",
        sourceType: (0, $4d5e0871c06cee03$export$9d2de6eebf7462b5)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b5dc24f07146f55$var$RecommendationsInProjectList, props));
const $9b5dc24f07146f55$var$TitleStyles = (0, $gDPDy.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    color: 'color.text.subtle',
    position: 'relative'
});
const $9b5dc24f07146f55$var$ButtonBoxStyles = (0, $gDPDy.xcss)({
    paddingInline: 'space.050'
});
const $9b5dc24f07146f55$var$SubtitleStyles = (0, $gDPDy.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginTop: 'space.0'
});
const $9b5dc24f07146f55$var$ExperimentSidebarContentStyles = (0, $gDPDy.xcss)({
    height: '100%',
    overflow: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $b8A8x.SIDEBAR_WIDTH)}px`,
    padding: 'space.300',
    backgroundColor: 'elevation.surface.sunken',
    boxSizing: 'border-box',
    justifyContent: 'start',
    listStyle: 'none'
});
const $9b5dc24f07146f55$var$SidebarContainerStyles = (0, $gDPDy.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100vh - ${(0, $iqLcb.UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT)} - ${(0, $iqLcb.UNSAFE_DO_NOT_USE_BANNER_HEIGHT)})`
});
var $9b5dc24f07146f55$export$2e2bcd8739ae039 = $9b5dc24f07146f55$var$RecommendationsInProjectListContainer;

});
parcelRegister("e7L79", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca00a0b0814c499$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7053b7eb6b4b3f2af19b7e28dc524520>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bca00a0b0814c499$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "ui_projectsDirectoryTemplatesSidebar_RecommendationsInProjectList",
        "selections": [
            {
                "args": [
                    v0 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "experimentKey",
                        "value": "sidebarExperiment"
                    }
                ],
                "concreteType": "JiraProjectListViewTemplateConnection",
                "kind": "LinkedField",
                "name": "projectListViewTemplates",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraProjectListViewTemplateItem",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                "action": "THROW",
                                "path": "projectListViewTemplates.nodes.key"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "templateType"
                                },
                                "action": "THROW",
                                "path": "projectListViewTemplates.nodes.templateType"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "productKey"
                                },
                                "action": "THROW",
                                "path": "projectListViewTemplates.nodes.productKey"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "isProductLicensed"
                                },
                                "action": "THROW",
                                "path": "projectListViewTemplates.nodes.isProductLicensed"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "card_projectsDirectoryTemplatesSidebar_TemplateCard"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "preview_projectsDirectoryTemplatesSidebar_TemplatePreview"
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    v0 /*: any*/ 
                ],
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__id"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$bca00a0b0814c499$var$node.hash = "cb3cd1eb69b348c8ecc62b322098e37b";
var $bca00a0b0814c499$export$2e2bcd8739ae039 = $bca00a0b0814c499$var$node;

});

// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("bikf7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $877837f06cff650d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $877837f06cff650d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    title: {
        "id": "projects-directory-templates-sidebar.title",
        "defaultMessage": "Templates"
    },
    subtitle: {
        "id": "projects-directory-templates-sidebar.subtitle",
        "defaultMessage": "Preview a template for your next project"
    },
    moreTemplatesLink: {
        "id": "projects-directory-templates-sidebar.more-templates-link",
        "defaultMessage": "More templates"
    },
    closeButton: {
        "id": "projects-directory-templates-sidebar.close-button",
        "defaultMessage": "Close"
    },
    tryLozenge: {
        "id": "projects-directory-templates-sidebar.try-lozenge",
        "defaultMessage": "Try"
    },
    premiumLozenge: {
        "id": "projects-directory-templates-sidebar.premium-lozenge",
        "defaultMessage": "Premium"
    },
    productKeyBusinessLabelSpork: {
        "id": "projects-directory-templates-sidebar.product-key-business-label-spork",
        "defaultMessage": "Get Jira to use this template"
    },
    productKeySoftwareLabelSpork: {
        "id": "projects-directory-templates-sidebar.product-key-software-label-spork",
        "defaultMessage": "Get Jira to use this template"
    },
    productKeyServiceDeskLabel: {
        "id": "projects-directory-templates-sidebar.product-key-service-desk-label",
        "defaultMessage": "Get Jira Service Management to use this template"
    },
    productKeyProductDiscoveryLabel: {
        "id": "projects-directory-templates-sidebar.product-key-product-discovery-label",
        "defaultMessage": "Get Jira Product Discovery to use this template"
    },
    premiumTemplateDiscoveryLabelSpork: {
        "id": "projects-directory-templates-sidebar.premium-template-discovery-label-spork",
        "defaultMessage": "Upgrade to Jira Premium to use this template"
    }
});

});

parcelRegister("g0buz", function(module, exports) {

$parcel$export(module.exports, "useSetProjectListRightPanelState", () => $3d92352d561501b7$export$f7872413c3847449);

var $5pqbm = parcelRequire("5pqbm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $koeKL = parcelRequire("koeKL");
const $3d92352d561501b7$var$PROJECT_LIST_RIGHT_PANEL_STATE = 'projectListRightPanelState';
const $3d92352d561501b7$var$relayStoreUpdater = (store, userPreferencesRefId, state)=>{
    if (typeof userPreferencesRefId === 'string') {
        const record = store.get(userPreferencesRefId);
        record?.setValue(state, $3d92352d561501b7$var$PROJECT_LIST_RIGHT_PANEL_STATE);
    }
};
const $3d92352d561501b7$export$f7872413c3847449 = (userPreferencesRefId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [commit] = (0, $8Uumt.useMutation)((0, $5pqbm.default));
    const setRightPanelState = (0, $5uXOq.useCallback)((state)=>{
        commit({
            variables: {
                cloudId: cloudId,
                state: state
            },
            optimisticUpdater: (store)=>$3d92352d561501b7$var$relayStoreUpdater(store, userPreferencesRefId, state),
            updater: (store, { // @ts-expect-error TS-2339 - Property 'jira' does not exist on type 'setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation$data | null | undefined'.
            jira: { userPreferences: { setProjectListRightPanelState: { projectListRightPanelState: projectListRightPanelState } } } })=>$3d92352d561501b7$var$relayStoreUpdater(store, userPreferencesRefId, projectListRightPanelState ?? state),
            onCompleted: ({ jira: { // @ts-expect-error(Suppressed for relay bump) - Property 'userPreferences' does not exist on type '{ readonly userPreferences: { readonly setProjectListRightPanelState: { readonly errors: readonly { readonly extensions: { readonly statusCode: number | null | undefined; } | null | undefined; readonly message: string | null | undefined; }[] | null | undefined; readonly projectListRightPanelState: JiraProjectListRig...'.
            userPreferences: { setProjectListRightPanelState: { success: success, errors: errors } } } })=>{
                const error = (errors ?? [])[0];
                if (!success || error) {
                    const errorMessage = `error on set project list right panel state: ${error.message}`;
                    const statusCode = error.extensions?.statusCode;
                    (0, $jcw0u.default)({
                        error: new Error(`status code: ${statusCode ?? 'unknown'}, ${errorMessage}`),
                        meta: {
                            id: 'jiraSetProjectListRightPanelStateError',
                            packageName: 'jiraGrowthRecommendationsInProjectList'
                        }
                    });
                }
            },
            onError: (error)=>{
                (0, $jcw0u.default)({
                    error: new Error(`jiraSetProjectListRightPanelStateMutationError with ${error.message}`),
                    meta: {
                        id: 'jiraSetProjectListRightPanelStateMutationError',
                        packageName: 'jiraGrowthRecommendationsInProjectList'
                    }
                });
            }
        });
    }, [
        cloudId,
        commit,
        userPreferencesRefId
    ]);
    return setRightPanelState;
};

});
parcelRegister("5pqbm", function(module, exports) {

$parcel$export(module.exports, "default", () => $faa907682b1711b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f982c84219e38d14c162a90f7e73d838>>
 * @relayHash 932a6ab30b4abea8c4b298d0299ba01a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9fc45f1ccb390d27ba078874be435f11bb5799b236a50a6fc32b19b5b705f8b
const $faa907682b1711b4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "state"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "state",
            "variableName": "state"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectListRightPanelState"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserPreferencesMutation",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProjectListRightPanelStateMutationPayload",
                                    "kind": "LinkedField",
                                    "name": "setProjectListRightPanelState",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserPreferencesMutation",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProjectListRightPanelStateMutationPayload",
                                    "kind": "LinkedField",
                                    "name": "setProjectListRightPanelState",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ],
                                                            "type": "BulkMutationErrorExtension"
                                                        }
                                                    ]
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c9fc45f1ccb390d27ba078874be435f11bb5799b236a50a6fc32b19b5b705f8b",
            "metadata": {},
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$faa907682b1711b4$var$node.hash = "1cbcdd010c06eb6470327729729fba37";
var $faa907682b1711b4$export$2e2bcd8739ae039 = $faa907682b1711b4$var$node;

});


parcelRegister("44MrF", function(module, exports) {

$parcel$export(module.exports, "TemplateCard", () => $4f58fd6771362ed5$export$ba340e850b866867);

var $i2l6t = parcelRequire("i2l6t");

var $5uXOq = parcelRequire("5uXOq");

var $ad1F8 = parcelRequire("ad1F8");

var $8Uumt = parcelRequire("8Uumt");

var $1GvOC = parcelRequire("1GvOC");

var $gPt5r = parcelRequire("gPt5r");
var $85183 = parcelRequire("85183");
var $8zGNj = parcelRequire("8zGNj");
var $kHj7L = parcelRequire("kHj7L");
var $gDPDy = parcelRequire("gDPDy");

var $58GFP = parcelRequire("58GFP");

var $47gW9 = parcelRequire("47gW9");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $12d8n = parcelRequire("12d8n");

var $bKCrm = parcelRequire("bKCrm");

var $duTbU = parcelRequire("duTbU");

var $2tT7R = parcelRequire("2tT7R");

var $eAf7Q = parcelRequire("eAf7Q");

var $b8A8x = parcelRequire("b8A8x");

var $bikf7 = parcelRequire("bikf7");

var $4PwcH = parcelRequire("4PwcH");

var $9yRd8 = parcelRequire("9yRd8");

var $9jWfA = parcelRequire("9jWfA");
const $4f58fd6771362ed5$export$ba340e850b866867 = ({ dataRef: dataRef, recommendedProductIds: recommendedProductIds, setTemplatePreviewKey: setTemplatePreviewKey, index: index })=>{
    const environment = (0, $2tT7R.useEnvironment)();
    const { fireInteractedUIEvent: fireInteractedUIEvent } = (0, $eAf7Q.useFireCrossFlowAnalyticsEvents)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $12d8n.useAnalyticsEvents)();
    const crossFlow = (0, $ad1F8.useCrossFlow)();
    const { methods: { open: openProjectCreate } } = (0, $bKCrm.useProjectCreateDrawer)();
    const cardEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'card'
    });
    const cardHoveredEvent = createAnalyticsEvent({
        action: 'hovered',
        actionSubject: 'card'
    });
    const template = (0, $8Uumt.useFragment)((0, $i2l6t.default), dataRef);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { title: title, shortDescription: shortDescription, key: key, isProductLicensed: isProductLicensed, isPremiumOnly: isPremiumOnly, productKey: productKey, templateType: templateType, recommendationSessionId: recommendationSessionId, canCreate: canCreate } = template;
    const { shouldPromptJsmTrial: shouldPromptJsmTrial } = (0, $4PwcH.checkShouldPromptJsmTrial)({
        templateKey: key,
        isProductLicensed: isProductLicensed,
        canCreate: canCreate
    });
    const [isJsmPremiumUpgradeModalOpen, setIsJsmPremiumUpgradeModalOpen] = (0, $5uXOq.useState)(false);
    const entryPoint = (0, $4mO32.useEntryPoint)((0, $duTbU.servicedeskStandardToPremiumModalEntryPoint), {});
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPoint.entryPointActions);
    const extensions = (0, $5uXOq.useMemo)(()=>{
        const mergedExtensions = (0, $9jWfA.buildCrossflowExtensions)({
            templateId: key,
            recommendationSessionId: recommendationSessionId,
            templateType: templateType
        });
        if (key === (0, $58GFP.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY) && (0, $4R6GH.fg)('fix_advanced_itsm_recommendation_cross_flow')) Object.assign(mergedExtensions, {
            edition: 'premium'
        });
        return mergedExtensions;
    }, [
        key,
        recommendationSessionId,
        templateType
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(cardEvent, 'templateCard', {
            key: key,
            productKey: productKey,
            isProductLicensed: isProductLicensed,
            isPremiumOnly: isPremiumOnly,
            templateType: templateType,
            recommendationSessionId: recommendationSessionId,
            extensions: extensions
        });
        if (shouldPromptJsmTrial) {
            setIsJsmPremiumUpgradeModalOpen(true);
            return;
        }
        if (!isProductLicensed && crossFlow.isEnabled && (0, $b8A8x.PROJECT_TYPE_TARGETS_MAP)[productKey] && (0, $b8A8x.getProductTypeCcpReferenceIdMapForEnv)(environment)[productKey]) {
            fireInteractedUIEvent({
                action: 'clicked',
                actionSubject: 'card',
                actionSubjectId: 'templateCard'
            }, {
                recommendedProductIds: recommendedProductIds,
                recommendationSession: {
                    id: recommendationSessionId,
                    type: 'appRec'
                },
                targetProductId: (0, $b8A8x.getProductTypeCcpReferenceIdMapForEnv)(environment)[productKey],
                source: 'projectsDirectorySidebarSection'
            });
            crossFlow.api.open({
                journey: (0, $ad1F8.Journeys).GET_STARTED,
                targetProduct: (0, $b8A8x.PROJECT_TYPE_TARGETS_MAP)[productKey],
                sourceComponent: 'projectsDirectorySidebar',
                sourceContext: 'templateCard',
                extensions: extensions
            });
            return;
        }
        openProjectCreate({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            selectedProjectType: productKey.toLowerCase(),
            showExperienceSelection: false,
            defaultSelectedTemplateKey: key,
            source: (0, $b8A8x.PROJECT_CREATE_SOURCE),
            ...(0, $4R6GH.fg)('productionise_msr_for_jsm_jpd_template_recos') && {
                recommendationSessionId: recommendationSessionId
            }
        });
    }, [
        cardEvent,
        key,
        productKey,
        isProductLicensed,
        isPremiumOnly,
        templateType,
        recommendationSessionId,
        extensions,
        crossFlow,
        environment,
        openProjectCreate,
        fireInteractedUIEvent,
        shouldPromptJsmTrial,
        recommendedProductIds
    ]);
    const onPreviewDismiss = ()=>{
        setTemplatePreviewKey((current)=>{
            if (current === key) return null;
            return current;
        });
    };
    const onPreviewStart = ()=>{
        (0, $8zOmE.fireUIAnalytics)(cardHoveredEvent, 'templateCard', {
            key: key,
            productKey: productKey,
            isProductLicensed: isProductLicensed,
            templateType: templateType,
            isPremiumOnly: isPremiumOnly
        });
        setTemplatePreviewKey(key);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
        as: "li",
        xcss: $4f58fd6771362ed5$var$PaddedCardStyles,
        onMouseEnter: onPreviewStart,
        onMouseLeave: onPreviewDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8zGNj.default), {
        padding: "space.200",
        "data-testId": `projects-directory-templates-sidebar.ui.template-card-${index}`,
        xcss: $4f58fd6771362ed5$var$CardStyles,
        onFocus: onPreviewStart,
        onBlur: onPreviewDismiss,
        onClick: onClick,
        tabIndex: 0,
        ...shouldPromptJsmTrial && {
            ref: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85183.default), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yRd8.default), {
        keyRef: template
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHj7L.default), {
        as: "div",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
        as: "span",
        xcss: $4f58fd6771362ed5$var$TitleStyles
    }, title, ' ', !isProductLicensed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GvOC.default), {
        appearance: "new"
    }, formatMessage((0, $bikf7.messages).tryLozenge)), isProductLicensed && isPremiumOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GvOC.default), {
        appearance: "new"
    }, formatMessage((0, $bikf7.messages).premiumLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
        as: "p",
        xcss: $4f58fd6771362ed5$var$DescriptionStyles
    }, shortDescription))))), isJsmPremiumUpgradeModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPoint.entryPointReferenceSubject,
        id: "standard-to-premium-modal",
        packageName: "jira-cmdb-upsell-page",
        teamName: "ITOps Mithril" // assigning to Mithril for the experiment
        ,
        entryPointActions: entryPoint.entryPointActions,
        runtimeProps: {
            onClose: ()=>{
                setIsJsmPremiumUpgradeModalOpen(false);
            },
            origin: 'templateCard'
        }
    }));
};
const $4f58fd6771362ed5$var$PaddedCardStyles = (0, $gDPDy.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    paddingBlock: 'space.100'
});
const $4f58fd6771362ed5$var$CardStyles = (0, $gDPDy.xcss)({
    width: '100%',
    textAlign: 'left',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    ':hover': {
        background: 'elevation.surface.overlay',
        boxShadow: 'elevation.shadow.overlay'
    },
    ':focus': {
        background: 'elevation.surface.overlay',
        boxShadow: 'elevation.shadow.overlay'
    }
});
const $4f58fd6771362ed5$var$TitleStyles = (0, $gDPDy.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text'
});
const $4f58fd6771362ed5$var$DescriptionStyles = (0, $gDPDy.xcss)({
    margin: '0',
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("i2l6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc42b42d7c2fc35b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<42195c960acd5f7dce05219d654c4a0f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bc42b42d7c2fc35b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "card_projectsDirectoryTemplatesSidebar_TemplateCard",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW",
            "path": "title"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "shortDescription"
            },
            "action": "THROW",
            "path": "shortDescription"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isProductLicensed"
            },
            "action": "THROW",
            "path": "isProductLicensed"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isPremiumOnly"
            },
            "action": "THROW",
            "path": "isPremiumOnly"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "canCreate"
            },
            "action": "THROW",
            "path": "canCreate"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "productKey"
            },
            "action": "THROW",
            "path": "productKey"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "recommendationSessionId"
            },
            "action": "THROW",
            "path": "recommendationSessionId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "templateType"
            },
            "action": "THROW",
            "path": "templateType"
        },
        {
            "kind": "FragmentSpread",
            "name": "icon_projectsDirectoryTemplatesSidebar_CardIcon"
        }
    ],
    "type": "JiraProjectListViewTemplateItem"
};
$bc42b42d7c2fc35b$var$node.hash = "92503294b576eedee21223387c1265a7";
var $bc42b42d7c2fc35b$export$2e2bcd8739ae039 = $bc42b42d7c2fc35b$var$node;

});

parcelRegister("duTbU", function(module, exports) {

$parcel$export(module.exports, "servicedeskStandardToPremiumModalEntryPoint", () => $7e434ef2c7309233$export$d21d0874477624e6);

var $auHvw = parcelRequire("auHvw");

var $9zf4T = parcelRequire("9zf4T");

const $7e434ef2c7309233$export$d21d0874477624e6 = (0, $9zf4T.createEntryPoint)({
    root: (0, $auHvw.JSResourceForInteraction)(()=>(parcelRequire("gTgDi")), {
        moduleId: "8d5c4464"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gTgDi", function(module, exports) {

let $c4beaf57bbb22420$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c4beaf57bbb22420$var$load("cM9em"),
    $c4beaf57bbb22420$var$load("fr9NE"),
    $c4beaf57bbb22420$var$load("h2MrD"),
    $c4beaf57bbb22420$var$load("bYT2S"),
    $c4beaf57bbb22420$var$load("icbXl")
]).then(()=>parcelRequire('997lH'));

});


parcelRegister("4PwcH", function(module, exports) {

$parcel$export(module.exports, "checkShouldPromptJsmTrial", () => $f2a3c4e5a230157d$export$aa1475d77bc9ab5f);

var $58GFP = parcelRequire("58GFP");

var $4R6GH = parcelRequire("4R6GH");
const $f2a3c4e5a230157d$export$aa1475d77bc9ab5f = ({ templateKey: templateKey, isProductLicensed: isProductLicensed, canCreate: canCreate })=>{
    return {
        shouldPromptJsmTrial: templateKey === (0, $58GFP.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY) && isProductLicensed && !canCreate && (0, $4R6GH.fg)('jsm_it_service_management_advanced_template')
    };
};

});

parcelRegister("9yRd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0567ec817d99d1fe$export$2e2bcd8739ae039);

var $cXHh4 = parcelRequire("cXHh4");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $gAR53 = parcelRequire("gAR53");
const $0567ec817d99d1fe$export$f4619d70a16e5ea0 = ({ keyRef: keyRef })=>{
    const { iconUrl: iconUrl, iconDarkUrl: iconDarkUrl } = (0, $8Uumt.useFragment)((0, $cXHh4.default), keyRef);
    if (!iconUrl || !iconDarkUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0567ec817d99d1fe$var$IconImage, {
        alt: "",
        src: iconUrl,
        srcDark: iconDarkUrl
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0567ec817d99d1fe$var$IconImage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $gAR53.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1bsb1ylp _4t3i1ylp",
            __cmplp.className
        ])
    });
});
var $0567ec817d99d1fe$export$2e2bcd8739ae039 = $0567ec817d99d1fe$export$f4619d70a16e5ea0;

});
parcelRegister("cXHh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $26eafe52be73ae19$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4fd4936ca5f864fb79a486e481337d84>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $26eafe52be73ae19$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "icon_projectsDirectoryTemplatesSidebar_CardIcon",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "iconUrl"
        },
        {
            "kind": "ScalarField",
            "name": "iconDarkUrl"
        }
    ],
    "type": "JiraProjectListViewTemplateItem"
};
$26eafe52be73ae19$var$node.hash = "c402fd47c91e565afa2bde202876eaf8";
var $26eafe52be73ae19$export$2e2bcd8739ae039 = $26eafe52be73ae19$var$node;

});


parcelRegister("9jWfA", function(module, exports) {

$parcel$export(module.exports, "buildCrossflowExtensions", () => $4013de4e0b6e964b$export$11382497cf741299);

var $ha0ZM = parcelRequire("ha0ZM");
const $4013de4e0b6e964b$export$11382497cf741299 = (args)=>{
    const { templateId: templateId, recommendationSessionId: recommendationSessionId, templateType: templateType } = args;
    const provisioningExtensions = (0, $ha0ZM.createProvisioningPageExtensions)({
        actions: {
            primary: {
                behaviour: (0, $ha0ZM.Behaviours).LAND,
                prompt: (0, $ha0ZM.Prompts).NEXT,
                options: {
                    targetTab: (0, $ha0ZM.TargetTabs).SAME,
                    urlParams: {
                        templateId: templateType
                    }
                }
            }
        }
    });
    const recoExtensions = (0, $ha0ZM.createRecommendationContextExtensions)({
        recommendationSessionId: recommendationSessionId,
        entityId: templateId
    });
    const mergedExtensions = {};
    Object.assign(mergedExtensions, provisioningExtensions, recoExtensions);
    return mergedExtensions;
};

});


parcelRegister("58Hlr", function(module, exports) {

$parcel$export(module.exports, "TemplatePreview", () => $ff584b3cb39806ab$export$48a171bbad47b95a);

var $54XGm = parcelRequire("54XGm");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $gAR53 = parcelRequire("gAR53");

var $gPt5r = parcelRequire("gPt5r");
var $kHj7L = parcelRequire("kHj7L");
var $gDPDy = parcelRequire("gDPDy");

var $iqLcb = parcelRequire("iqLcb");

var $b8A8x = parcelRequire("b8A8x");
const $ff584b3cb39806ab$export$48a171bbad47b95a = ({ update: update, previewRef: previewRef })=>{
    const { title: title, description: description, key: key, previewUrl: previewUrl, previewDarkUrl: previewDarkUrl } = (0, $8Uumt.useFragment)((0, $54XGm.default), previewRef);
    // Required to update the Popup location when the trigger has moved during side nav animation
    (0, $5uXOq.useEffect)(()=>{
        if (update) update();
    }, [
        update
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
        xcss: [
            $ff584b3cb39806ab$var$TemplatePreviewWrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ff584b3cb39806ab$var$TemplateAreaContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHj7L.default), {
        xcss: $ff584b3cb39806ab$var$PreviewWrapperStyles,
        space: "space.500"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHj7L.default), {
        space: "space.100",
        xcss: $ff584b3cb39806ab$var$TextContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
        as: "span",
        xcss: $ff584b3cb39806ab$var$TitleStyles
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
        as: "p",
        xcss: $ff584b3cb39806ab$var$DescriptionStyles
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gPt5r.default), {
        as: "span",
        xcss: $ff584b3cb39806ab$var$ImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ff584b3cb39806ab$var$PreviewImage, {
        src: previewUrl,
        key: key,
        alt: "",
        srcDark: previewDarkUrl
    })))));
};
const $ff584b3cb39806ab$var$TemplatePreviewWrapperStyles = (0, $gDPDy.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(100vw - ${(0, $b8A8x.SIDEBAR_WIDTH)}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100vh - ${(0, $iqLcb.UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT)} - ${(0, $iqLcb.UNSAFE_DO_NOT_USE_BANNER_HEIGHT)} - 4px)`,
    backgroundColor: 'elevation.surface',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
    ':empty': {
        display: 'none'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ff584b3cb39806ab$var$TemplateAreaContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb12it _1tku1ssb",
            __cmplp.className
        ])
    });
});
const $ff584b3cb39806ab$var$ImageWrapperStyles = (0, $gDPDy.xcss)({
    aspectRatio: '100/62'
});
const $ff584b3cb39806ab$var$TextContainerStyles = (0, $gDPDy.xcss)({
    color: 'color.text'
});
const $ff584b3cb39806ab$var$TitleStyles = (0, $gDPDy.xcss)({
    font: "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-regular, 400)"
});
const $ff584b3cb39806ab$var$DescriptionStyles = (0, $gDPDy.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    margin: '0'
});
const $ff584b3cb39806ab$var$PreviewWrapperStyles = (0, $gDPDy.xcss)({
    backgroundColor: 'elevation.surface'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ff584b3cb39806ab$var$PreviewImage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $gAR53.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_5ral1f51 _rsufjp4b _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("54XGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b400eee27cc206b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c7489b2f76248bf4f8fd236f165f98f8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1b400eee27cc206b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "preview_projectsDirectoryTemplatesSidebar_TemplatePreview",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW",
            "path": "title"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "description"
            },
            "action": "THROW",
            "path": "description"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "previewUrl"
            },
            "action": "THROW",
            "path": "previewUrl"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "previewDarkUrl"
            },
            "action": "THROW",
            "path": "previewDarkUrl"
        }
    ],
    "type": "JiraProjectListViewTemplateItem"
};
$1b400eee27cc206b$var$node.hash = "83f2fe24a77e391a2bf8c4e6b7ad6e3b";
var $1b400eee27cc206b$export$2e2bcd8739ae039 = $1b400eee27cc206b$var$node;

});


parcelRegister("iYN9U", function(module, exports) {

$parcel$export(module.exports, "JiraProjectListSidePanelSkipLink", () => $50e065dc625d4db2$export$32072395400d2f38);

var $koVbs = parcelRequire("koVbs");

var $iqLcb = parcelRequire("iqLcb");

var $lJanr = parcelRequire("lJanr");
const $50e065dc625d4db2$export$32072395400d2f38 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $iqLcb.useCustomSkipLink)('jira-project-list-side-panel', formatMessage((0, $lJanr.default).skipToRightSidePanel), 4);
    return null;
};

});
parcelRegister("lJanr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dc906b2ec0e6223$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7dc906b2ec0e6223$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    skipToRightSidePanel: {
        "id": "projects-directory-templates-sidebar.skip-link.skip-to-right-side-panel",
        "defaultMessage": "Skip to Side Panel"
    }
});

});





//# sourceMappingURL=projects-directory-templates-sidebar.1016f084.js.map
